import React from "react";
import { registerOperatorRoute } from "../../../routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons";
import ProductSpecTable from "./components/ProductSpecTable";
import ProductSpecsForm from "./pages/ProductSpecsForm";

registerOperatorRoute({
  isNavigationLink: false,
  isSetting: false,
  isProductMetadata: true,
  path: "/product-specs/create",
  mainComponent: ProductSpecsForm
});

registerOperatorRoute({
  isNavigationLink: false,
  isSetting: false,
  isProductMetadata: true,
  path: "/product-specs/:productSpecId",
  mainComponent: ProductSpecsForm
});

registerOperatorRoute({
  isNavigationLink: true,
  isSetting: false,
  isProductMetadata: true,
  mainComponent: ProductSpecTable,
  path: "/product-specs",
  // eslint-disable-next-line react/display-name
  SidebarIconComponent: (props) => <FontAwesomeIcon icon={faList} {...props} />,
  sidebarI18nLabel: "admin.dashboard.productSpecsLabel"
});
